require('prismjs/themes/prism-okaidia.css')

// Automatically refresh page content
// source: https://github.com/gatsbyjs/gatsby/issues/9087
// and https://stackoverflow.com/questions/58699453/gatsby-blog-every-new-post-requires-hard-refresh-after-build

exports.onServiceWorkerUpdateReady = () => window.location.reload(true)
